import app from './app';
import { USERPROFILE_SERVICE_URL, REPORT_SERVICE_URL, ORDER_SERVICE_URL } from './../../libs/constants';
import { saveAs } from 'file-saver';

//POST
const getCompanyList = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = {
            headers: {
                "DRS-Fetch-Type": "getCompanyList"
            }
        };
        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/company/' + userId, null, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_CUSTOMIZED_REPORTS_COMPANY_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//POST
const getLegalEntityList = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getLegalEntityList"
        }
    };
    try {
        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/legalEntity/' + userId, requestData, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_LEGAL_ENTITY_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//POST
const getCustomizedReportsList = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getCustomizedReportsList"
        }
    };
    try {
        const response = await api.post('order' + REPORT_SERVICE_URL + 'customized/list/' + userId, requestData, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_CUSTOMIZED_REPORTS_LIST",
            payload: response.data
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

const setFilters = (filters) => {
    return {
        type: "SET_CUSTOMIZED_REPORTS_FILTERS",
        payload: filters
    }
}

const setIsSubmitClicked = (value) => {
    return {
        type: "SET_IS_SUBMIT_CLICKED",
        payload: value
    }
}

const setCompany = (company) => {
    return {
        type: "SET_COMPANY",
        payload: company
    }
}

//POST
const generateConsolidatedReport = (userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "generateConsolidatedReport"
        }
    };
    try {
        await api.post(REPORT_SERVICE_URL + 'generate/consrep/' + userId, requestData, headerConfig)
            .then(response => {
                dispatch(app.setLoading(false));
                dispatch({
                    type: "SET_CONSOLIDATED_REPORT",
                    payload: response
                });

                if (response.data.includes("successfully")) {
                    const modalObject = {
                        type: "confirm",
                        messageText: "We are currently working for building your Consolidated Report.",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "HOURGLASS_ICON",
                        consolidatedReport: true
                    }
                    dispatch(app.setAppModal(modalObject));
                }
                else {
                    const modalObject = {
                        type: "confirm",
                        messageText: "No records found matching your criteria",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "REJECT_RED_ICON",
                        consolidatedReport: true,
                        childComponentToRender: "Please modify your filter selection and try again."
                    }
                    dispatch(app.setAppModal(modalObject));
                }
            });
    } catch (error) {
        dispatch(app.setLoading(false));
        const modalObject = {
            type: "confirm",
            messageText: "No records found matching your criteria",
            rounded: true,
            acceptHandler: null,
            rejectHandler: null,
            hideConfirmationButtons: true,
            iconToRender: "REJECT_RED_ICON",
            consolidatedReport: true,
            childComponentToRender: "Please modify your filter selection and try again."
        }
        dispatch(app.setAppModal(modalObject));
    }
};

//POST
const getConsolidatedReportList = (userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getConsolidatedReportList"
        }
    };
    try {
        const response = await api.post(REPORT_SERVICE_URL + 'consrep/list/' + userId, null, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_CONSOLIDATED_REPORT_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
    }
};

//POST
const downloadConsolidatedReportAfr = (userId,userType, reportId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };

    await api.post(REPORT_SERVICE_URL + 'download/consrep/' + userId + "/" + reportId + "?reportType=afr", null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), reportId.split("-")[0] +"_" + userType + "_A&FReport.xlsx");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

//POST
const downloadConsolidatedReportSbr = (userId, reportId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf"
        },
        responseType: "blob"
    };

    await api.post(REPORT_SERVICE_URL + 'download/consrep/' + userId + "/" + reportId + "?reportType=sbr", null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), reportId + "_SustainabilityReport.pdf");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

//POST
const downloadConsolidatedReportDsr = (userId, reportId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .zip"
        },
        responseType: "blob"
    };

    await api.post(REPORT_SERVICE_URL + 'download/consrep/' + userId + "/" + reportId + "?reportType=dsr", null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), reportId + "_DataSanitizationReport.zip");
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const setLegalEntityList = (data) => {
    return {
        type: "SET_LEGAL_ENTITY_LIST",
        payload: data
    }
}

const customizedReportActions = {
    getCompanyList: getCompanyList,
    getLegalEntityList: getLegalEntityList,
    getCustomizedReportsList: getCustomizedReportsList,
    setFilters: setFilters,
    setIsSubmitClicked: setIsSubmitClicked,
    generateConsolidatedReport: generateConsolidatedReport,
    getConsolidatedReportList: getConsolidatedReportList,
    downloadConsolidatedReportAfr: downloadConsolidatedReportAfr,
    downloadConsolidatedReportSbr: downloadConsolidatedReportSbr,
    downloadConsolidatedReportDsr: downloadConsolidatedReportDsr,
    setCompany: setCompany,
    setLegalEntityList: setLegalEntityList
}

export default customizedReportActions;